import React, { useEffect, useState } from "react";
import InputText from "../common/InputText";
import "react-phone-input-2/lib/style.css";
import PhoneInput from "react-phone-input-2";
import Google from "../../assets/svg/google-icon.svg";
import { useComponent } from "../common/Modal";
import { useForm } from "react-hook-form";
import { userSignup } from "../../services/apiServices";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { ClipLoader } from "react-spinners"; // Loader Component
import { GoogleOAuthProvider } from "@react-oauth/google";
import GoogleAuthButton from "../common/GoogleWrapper";
import { useTranslation } from "react-i18next";

const SignUp = () => {
  const [loading, setLoading] = useState(false);
  const {
    register,
    handleSubmit,
    formState: { errors },
    watch,
    setValue,
    trigger,
    reset,
  } = useForm();

  const { setCurrentComponent, setUserData } = useComponent();
  const { t } = useTranslation();

  const onSubmit = async (data) => {
    try {
      setLoading(true);
      const payload = {
        fullname: data?.fullName,
        email: data?.email?.toLowerCase(),
        password: data?.password,
        companyName: data?.companyName,
        phone: `${data?.phoneNumber}`,
      };
      const response = await userSignup(payload);
      if (response?.data?.statusCode == 200) {
        setUserData(response?.data?.data);
        toast.success(response?.data?.message || t("signup_success"), {
          position: "top-right",
          autoClose: 3000,
        });
        setCurrentComponent("otpVerification");
      } else {
        toast.error(response?.data?.message || t("signup_failed"), {
          position: "top-right",
          autoClose: 3000,
        });
      }
    } catch (error) {
      console.warn("error in sinup: ", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    register("phoneNumber", {
      required: t("signup_phone_required"),
      minLength: {
        value: 6,
        message: t("signup_phone_too_short"),
      },
    });
  }, [register, t]);

  return (
    <div>
      <h2 className="text-2xl text-primary-text font-semibold text-center">
        {t("signup_title")}
      </h2>

      <h5 className="text-center mt-2 text-lg text-[#5D5D5D] font-medium">
        {t("signup_subtitle")}
      </h5>

      <form onSubmit={handleSubmit(onSubmit)}>
        <InputText
          title={t("signup_fullname")}
          placeholder={t("signup_fullname_placeholder")}
          type="text"
          {...register("fullName", {
            required: t("signup_fullname_required"),
            minLength: { value: 3, message: t("signup_fullname_min") },
          })}
          error={errors.fullName?.message}
          value={watch("fullName")}
          onChange={(e) => {
            setValue("fullName", e.target.value);
            trigger("fullName");
          }}
        />

        <InputText
          title={t("signup_company")}
          placeholder={t("signup_company_placeholder")}
          type="text"
          {...register("companyName", {
            required: t("signup_company_required"),
            minLength: { value: 2, message: t("signup_company_min") },
          })}
          error={errors.companyName?.message}
          value={watch("companyName")}
          onChange={(e) => {
            setValue("companyName", e.target.value);
            trigger("companyName");
          }}
        />

        <div className="mt-4 font-200">
          <label className="block mb-2 text-sm font-medium font-bold text-black-500 bold">
            {t("signup_phone")}
          </label>
          <PhoneInput
            className="bg-[#F1F1F1]"
            placeholder={t("signup_phone_placeholder")}
            country={"ro"}
            value={watch("phoneNumber")}
            onChange={(phone) => {
              setValue("phoneNumber", phone);
              trigger("phoneNumber");
            }}
            inputProps={{
              name: "phoneNumber",
              required: true,
            }}
            inputStyle={{
              width: "100%",
              backgroundColor: "#F1F1F1",
              borderRadius: "8px",
              height: "45px",
            }}
          />
          {errors.phoneNumber && (
            <p className="text-red-600 text-sm mt-1">
              {errors.phoneNumber.message}
            </p>
          )}
        </div>

        <InputText
          title={t("signup_email")}
          placeholder={t("signup_email_placeholder")}
          type="email"
          {...register("email", {
            required: t("signup_email_required"),
            pattern: {
              value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
              message: t("signup_email_invalid"),
            },
          })}
          error={errors.email?.message}
          value={watch("email")}
          onChange={(e) => {
            setValue("email", e.target.value);
            trigger("email");
          }}
        />

        <InputText
          title={t("signup_password")}
          placeholder={t("signup_password_placeholder")}
          type="password"
          password={true}
          {...register("password", {
            required: t("signup_password_required"),
            minLength: {
              value: 6,
              message: t("signup_password_minlength"),
            },
          })}
          error={errors.password?.message}
          value={watch("password")}
          onChange={(e) => {
            setValue("password", e.target.value);
            trigger("password");
          }}
        />
        <div className="mt-6">
          <button
            type="submit"
            className="w-full text-base bg-red-600 text-white p-3 rounded-[121px] font-semibold flex justify-center items-center"
            disabled={loading}
          >
            {loading ? (
              <ClipLoader size={20} color="#fff" />
            ) : (
              t("signup_continue")
            )}
          </button>
        </div>
      </form>
      <div className="mt-3">
        <p
          onClick={() => setCurrentComponent("signIn")}
          className="text-center text-lg underline cursor-pointer font-semibold text-red-600"
        >
          {t("signup_signin")}
        </p>
      </div>
    </div>
  );
};

export default SignUp;
